import { Chip } from "@mui/material";
import { CREW_SKILL_COLORS } from "../../../../constants";

type CrewSkillTagProps = {
  label: string;
};

export const CrewSkillTag = ({ label }: CrewSkillTagProps) => {
  const colors = CREW_SKILL_COLORS[label];

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        height: 20,
        borderRadius: "4px",
        fontSize: 11,
        fontWeight: 500,
        backgroundColor: colors?.background ?? "var(--dashboard-border-row)",
        color: colors?.color ?? "var(--dashboard-text-legend)",
        "& .MuiChip-label": { px: 0.75 },
      }}
    />
  );
};
